// Renderable cards
export const Highlights = {
  'Meta SWE Internships': {
    image: 'https://imgur.com/ymBJG7em.png',
    body: "Two three-month paid internships with Meta on Data Experiences and Instagram Subscriptions teams. Contributed directly to Meta's production codebases and bridged the gap between big data, Instagram's creators, and over two billion monthly active users.",
    page: 'https://www.facebook.com/careers/students-and-grads/?p[teams][0]=Internship%20-%20Engineering%2C%20Tech%20%26%20Design&p[teams][1]=Internship%20-%20Business&p[teams][2]=Internship%20-%20PhD&p[teams][3]=University%20Grad%20-%20PhD%20%26%20Postdoc&p[teams][4]=University%20Grad%20-%20Engineering%2C%20Tech%20%26%20Design&p[teams][5]=University%20Grad%20-%20Business&teams[0]=Internship%20-%20Engineering%2C%20Tech%20%26%20Design&teams[1]=Internship%20-%20Business&teams[2]=Internship%20-%20PhD&teams[3]=University%20Grad%20-%20PhD%20%26%20Postdoc&teams[4]=University%20Grad%20-%20Engineering%2C%20Tech%20%26%20Design&teams[5]=University%20Grad%20-%20Business#openpositions',
    external: true,
  },
  Groov: {
    image: 'https://imgur.com/QwXe6X5m.png',
    body: 'A music based social media that brings freestyle to the public. For this project, I took the role of Project Manager and Mobile Developer.',
    page: 'https://github.com/GroovTeam',
    external: true,
  },
  Tower: {
    image: 'https://imgur.com/2rbukiKm.png',
    body: 'A social media for the Tower at UCF. Keeps climbers in the know about route updates, and allows them to share sends and compete on leaderboards.',
    page: 'https://youtu.be/S631H8Txd64',
    external: true,
  },
  'Thread-Safe Hashmap Paper': {
    image: 'https://imgur.com/7gjRXiEm.png',
    body: 'Research paper outlining my findings while building a thread-safe hashmap in C++.',
    page: 'https://drive.google.com/file/d/1vpsYcmD4U3v19azYlDq7PmDlHmA6NfEI/view?usp=sharing',
    external: true,
  },
  'Raytracer & Acceleration Structures': {
    image: 'https://imgur.com/QWUsreVm.png',
    body: 'Presentation outlining the results of a deep-dive into raytracing and acceleration structures in C++.',
    page: 'https://youtu.be/-4M1FN9226Q',
    external: true,
  },
  'UCF Programming Team': {
    image: 'https://imgur.com/iocS8B7m.png',
    body: 'Member of the UCF Programming Team. Solved hundreds of technical programming problems both in competitions and in practice. Here you can find some of the resulting solutions, some of which may be incomplete.',
    page: 'https://github.com/TylerMathis/progteam/tree/main',
    external: true,
  },
  Pathfinder: {
    image: 'https://imgur.com/qc0Q9Hym.png',
    body: 'Awesome pathfinding visualization, written entirely in Javascript!',
    page: 'pathfinder',
    external: false,
  },
  'VR Molecule Builder': {
    image: 'https://imgur.com/kQ2i8cam.png',
    body: 'VR application that allows the user to build organic molecules. Build in an effort to improve stereochemistry education materials.',
    page: 'https://drive.google.com/file/d/1W2QugDdjEtT40bghaI3PLtvp-3QBLKjQ/view',
    external: true,
  },
  Sixle: {
    image: 'https://imgur.com/hIJW1lNm.png',
    body: 'Wordle, but six letters!',
    page: 'sixle',
    external: false,
  },
}

// export const FreelanceWebDev = {
//   'Theatre Portfolio': {
//     image: 'https://imgur.com/eASjzUrm.jpg',
//     body: 'Dynamic portfolio built from scratch with React and Bootstrap, complete with Google Captcha V3 and automated email forms.',
//     page: 'https://briverairions.com',
//     external: true,
//   },
//   'Music Portfolio': {
//     image: 'https://imgur.com/qUrEj7Zm.jpg',
//     body: 'Dynamic portfolio built from scratch with React and Bootstrap, complete with a fully functioning admin panel, Google Captcha V3, automated email forms.',
//     page: 'https://zshimswebsite.com',
//     external: true,
//   },
// }

export const CellularAutomata = {
  'Predator Vs. Prey': {
    image: 'https://imgur.com/B266zePm.png',
    body: 'A realtime procedural simulation of the interactions between a species of predator and prey. This project was a catalyst for my interest in cellular automata.',
    page: 'predator-vs-prey',
    external: false,
  },
  "Conway's Game of Life": {
    image: 'https://imgur.com/vlLZPEBm.png',
    body: "Conway's Game of Life, run fully in the browser.",
    page: 'conways-game-of-life',
    external: false,
  },
}
